<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "EffContractNotificationSnackbar",

  computed: {
    ...mapState({
      text: state => state.effective_contract_notification_snackbar.text,
      snackbar: state => state.effective_contract_notification_snackbar.snackbar,
      timeout: state => state.effective_contract_notification_snackbar.timeout,
      color: state => state.effective_contract_notification_snackbar.color,
    }),
  },

  methods: {
    ...mapActions({
      setSnackbarAction: "effective_contract_notification_snackbar/setSnackbarAction",
      toggleSnackbarAction: "effective_contract_notification_snackbar/toggleSnackbarAction",
    }),
  }
}
</script>

<template>
  <v-snackbar
    bottom
    :value="snackbar"
    @input="toggleSnackbarAction"
    :color="color"
    :timeout="timeout"
  >
    <h4 class="h4">{{ text }}</h4>

    <template v-slot:action="{ attrs }">
      <v-btn
        color="white"
        text
        v-bind="attrs"
        @click="toggleSnackbarAction"
      >
        <v-icon small>fa-times</v-icon>
      </v-btn>
    </template>
  </v-snackbar>
</template>

<style scoped>

</style>